import React from 'react';
import { Typography } from '@mui/material';

const FlowFolderLabel = ({ path }) => (path ? (
    <Typography variant="body2" sx={{ color: '#888', fontSize: '0.8rem', overflowWrap: 'anywhere' }}>
        {path}
    </Typography>
) : null);

export default FlowFolderLabel;
